module.exports = __webpack_public_path__ + "static/media/beacon-presentation-bg.95fafdc4.jpg";